
    import { adobeAnalyticsDataUrl } from './src/ts/analytics-loader.ts';
    const script = document.createElement('script');
    script.src = adobeAnalyticsDataUrl;
    script.async = true;
    document.head.appendChild(script);
  